import { __decorate } from "tslib";
import { isObject } from "lodash-es";
import { State } from 'vue-class-state';
export class LogState {
  constructor(editorState) {
    this.editorState = editorState;
    this.logs = [];
    this.logText = '';
    this.consoleSpy = this.getConsoleSyp();
    // empty
  }

  clear() {
    this.logText = '';
    this.logs = [];
  }
  push(log) {
    this.logs.push(log);
    this.logText = [this.logText, log.content].join('\n');
  }
  getConsoleSyp() {
    const logMethods = ['log', 'error', 'info', 'warn'];
    const spy = new Proxy(console, {
      get: (target, key) => {
        if (!this.editorState.visible || !logMethods.includes(key)) {
          return target[key];
        }
        return (...args) => {
          try {
            args.forEach(item => {
              if (isObject(item)) {
                this.push({
                  level: key,
                  content: JSON.stringify(item, undefined, 2)
                });
              } else {
                this.push({
                  level: key,
                  content: String(item)
                });
              }
            });
          } catch (error) {
            console.error(error);
          }
          return target[key](...args);
        };
      }
    });
    return spy;
  }
}
__decorate([State], LogState.prototype, "logText", void 0);
//# sourceMappingURL=LogState.js.map
